module.exports = __webpack_public_path__ + "static/media/img-talent-profile-cards@2x.3872b08e.png";